<template>
  <aceHotel :revinate_token="revinate_token" :template="template" :portal="portal" :connection_data="connection_data" @emitRegistrationMethodData="handleEmit" />
</template>
<script>
import aceHotel from '@/components/custom/aceHotel/index'
export default {
  name: 'custom_template_ace_palm_springs',
  props: [ 'template', 'portal', 'connection_data' ],
  components: { aceHotel },
  data(){
    return{
      revinate_token: 'fb59dc40-a3f4-4efa-a4fb-e27fa37ed79a'
    }
  },
  methods: {
    handleEmit:function(data){
      this.$emit('emitRegistrationMethodData', data);
    }
  }
}
</script>
<style>
</style>